import { Component, inject } from '@angular/core';
import { Dialog } from '../dialog';
import {
  EEntityType,
  ERelationType,
  ITicket,
  TariffProductDefinition,
} from '@web/dtos';
import { TicketTileComponent } from '../../data-display/ticket-tile/ticket-tile.component';
import { ToTicketTilePipe } from '../../../pipes/to-ticket-tile/to-ticket-tile.pipe';
import { LanguagePipe } from '../../../pipes/language/language.pipe';
import { FilterTextsPipe } from '../../../pipes/filterTexts/filterTexts.pipe';
import { WebTextStore } from '../../../services/api/text/web-text-store.service';

export interface ITicketInformation {
  index: number;
  name: string;
  ticket: ITicket;
  productDefinition: TariffProductDefinition;
}

@Component({
  selector: 'aw-direct-ticket-information-dialog',
  imports: [
    TicketTileComponent,
    ToTicketTilePipe,
    LanguagePipe,
    FilterTextsPipe,
  ],
  templateUrl: './direct-ticket-information-dialog.component.html',
})
export class DirectTicketInformationDialogComponent extends Dialog<ITicketInformation> {
  protected readonly textStore: WebTextStore = inject(WebTextStore);
  protected readonly ERelationType: typeof ERelationType = ERelationType;
  protected readonly EEntityType: typeof EEntityType = EEntityType;
}
